import mixCalculosGraficaAvance from './mixCalculosGraficaAvance';

export default {
  computed: {

  },
  data() {
    return {
      AlaFecha: this.fechaAlInforme,
    };
  },
  mixins: [mixCalculosGraficaAvance],
  methods: {
    async generarPdfGraficaAvances() {
      const nombreTemplate = 'templateInformeGraficaAvances';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const fechaTitulo = `al ${datosFecha.fechaAl_texto}`;
      const logo = this.getCliente?.logo || '';

      // const fechas = this.getGraficaEjeX.map((fecha) =>
      // new Date(`${fecha} 00:00:0`).toLocaleDateString());
      const fechas = this.getGraficaEjeX.map((fecha) => this.$moment(fecha).format('MM/D/YYYY'));
      const puntosFormato = fechas.map((p) => this.formatoFechaSeparador(p, { letra: true, separador: '-', formatoMes: 'corto' }));

      // Arreglos para grafica
      const grafica = {
        fechas: ['', ...fechas],
        programadoPorcentaje: [0, ...this.getGraficaProgramadoData
          .map(({ porcentaje }) => porcentaje)],
        financieroPorcentaje: [0, ...this.getGraficaEstimacionesData
          .map(({ porcentaje }) => porcentaje)],
        fisicoPorcentaje: [0, ...this.getGraficaAvanceFisicoData
          .map(({ porcentaje }) => porcentaje)],
        programado: [0, ...this.getGraficaProgramadoData
          .map(({ importe }) => importe)],
        financiero: [0, ...this.getGraficaEstimacionesData
          .map(({ importeEstimadoAcumulado }) => importeEstimadoAcumulado)],
        fisico: [0, ...this.getGraficaAvanceFisicoData
          .map(({ importe }) => importe)],
        puntosLetra: ['', ...puntosFormato],
        ejeXLabels: ['', ...fechas.map((p, index) => index + 1)],
        programadoP: [0, ...this.getGraficaProgramadoData
          .map(({ porcentaje }) => porcentaje)]
          .map((p) => `${p}%`),
        financieroP:
        [0, ...this.getGraficaEstimacionesData
          .map(({ porcentaje }) => porcentaje)]
          .map((p) => `${p}%`),
        fisicoP: [0, ...this.getGraficaAvanceFisicoData
          .map(({ porcentaje }) => porcentaje)]
          .map((p) => `${p}%`),
        programadoI: [0, ...this.getGraficaProgramadoData
          .map(({ importe }) => importe)]
          .map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        financieroI: [0, ...this.getGraficaEstimacionesData
          .map(({ importeEstimadoAcumulado }) => importeEstimadoAcumulado)]
          .map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
        fisicoI: [0, ...this.getGraficaAvanceFisicoData
          .map(({ importe }) => importe)]
          .map((p) => `$${p.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),

      };

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          fecha: datosFecha,
          fechaTitulo,
          logo,
          numeroInforme: this.numeroInforme,
          grafica,
          footer: '',
        },
      }, `${this.contrato.numero}_GraficaAvances_${this.fechaAlInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
